import axios from '../../axios'

/*
 * 合作方渠道数据接口
 */

// 获取合作方渠道列表
export const getChannelList = (data) => {
    return axios({
        url: '/api/base/channel',
        method: 'get',
        data
    })
}

// 新增合作方渠道信息
export const saveChannel = (data) => {
    return axios({
        url: '/api/base/channel',
        method: 'post',
        data
    })
}

// 编辑角色信息
export const updateChannel = (data) => {
    return axios({
        url: '/api/base/channel',
        method: 'put',
        data
    })
}

// 删除合作方渠道列表
export const deleteChannel = (data) => {
    return axios({
        url: '/api/base/channel',
        method: 'delete',
        data
    })
}

// 删除合作方渠道列表
export const downloadChannelPoster = (data) => {
    return axios({
        url: '/api/base/download/channel/poster',
        method: 'post',
        data
    })
}

// 获取合作方渠道列表
export const getParentChannels = (data) => {
    return axios({
        url: '/api/base/channel/get/parent',
        method: 'POST',
        data
    })
}

// 渠道二维码导出下载
export const getQrcardExport = (data) => {
    return axios({
        url: '/api/base/qrcode/merge/export',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/base/channel.js